import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, catchError, debounceTime, map, of, shareReplay, startWith, tap } from 'rxjs';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { AutocompleteOption } from './istanze.service';

export interface ListOption {
    id: number | string
    descrizione: string
  }

  export interface IVia{
    id: number
    nome?: string
  }

  export interface ICivico{
        id: number
        via_id: number
        civico:number
        esponente?: string
        lat?: number
        lng?: number
        geom?: string
    }

@Injectable({
  providedIn: 'root',
})
export class UbicazioneService {

  constructor(
    @Inject(BACKEND_URLS) public backendUrls: BackendUrls,
    private _httpClient: HttpClient,
  ) {}


    getViaById(
        id_via: number,
    ): Observable<AutocompleteOption> {
        let serviceUrl: string = `${this.backendUrls.backendApiUrl}/ubicazione/vie/by_id`;
        if (!id_via) {
            return of(null)
        }
        return this._httpClient
            .get<AutocompleteOption[]>(serviceUrl, {
                params: { id_via },
            })
            .pipe(
                map((result) => result['data']),
                map((data) => {
                    return <AutocompleteOption>{
                        key: data['id'],
                        value: data['nome']
                    };
                })
            )


    }



  getViaByTerm(
    term: string,
  ): Observable<AutocompleteOption[]> {
    let serviceUrl: string  = `${this.backendUrls.backendApiUrl}/ubicazione/vie`;

    if (typeof term != 'string') {
      return of([]);
    }

    return this._httpClient
      .get<AutocompleteOption[]>(serviceUrl, {
        params: { nome:term },
      })
      .pipe(
        shareReplay(1),
        map((result) =>
          result['data'].map((data) => {
            return <AutocompleteOption>{
              key: data['id'],
              value: data['nome']
            };
          })
        ),
        catchError((err: Response) => {
          if (err.status === 200) {
            return of(true);
          }
          return of([]);
        })
      );
  }

  getCiviciByVia(
    idvia: string = '',
    term: string = '',
  ): Observable<AutocompleteOption[]> {
    let serviceUrl: string  = `${this.backendUrls.backendApiUrl}/ubicazione/civici`;

    if (typeof term != 'string' || !idvia) {
      return of([]);
    }

    return this._httpClient
      .get<AutocompleteOption[]>(serviceUrl, {
        params: { idvia:idvia, civico:term },
      })
      .pipe(
        shareReplay(1),
        map((result) =>
          result['data'].map((data) => {
            return <AutocompleteOption>{
              key: data['id'],
              value: data['lbl'],
              codvia: data['codvia'],
              lat: data['lat'],
              lng: data['lng'],
              //geom: data['geom']
            };
          })
        ),
        catchError((err: Response) => {
          if (err.status === 200) {
            return of(true);
          }
          return of([]);
        })
      );
  }

}
